import Shipments from "../../../containers/shipments/shipments";
import { getApiUrl } from "../../../utils/baseUrl";
import { filterTypeDictionary as filterType, analyticsTypeDictionary as analyticsType, autoSuggestLanguageDictionary as autosuggestLanguageOptions, categoryType } from "../../../core/global/global-country-dictionary";
import { globalCountryDetailsDictionary as globalCountryDetails } from "../../../core/global/global-country-details";

export const analyticDropdownOptions = [
  { value: "shipments", label: "Number of Shipments", two_table_header: "Number of Shipments" },
  { value: "weight", label: "Total Weight (kg)", two_table_header: "Total Weight (kg)" },
  { value: "value", label: "Total Shipment Value (USD)", two_table_header: "Total Shipment Value (USD)" },
];
export const trendsDropdownOptions = [
  { value: "shipments", label: "Shipments", table_header: "Total Shipments" },
  { value: "weight", label: "Weight (kg)", table_header: "Total Weight (kg)" },
  { value: "value", label: "Value (USD)", table_header: "Total Value (USD)" },
];
export const defaultData = {
  name: "Botswana Exports",
  customShipmentGrid: true,
  showUiUeLevelTwo: true,
  isProductChemicalPresent: true,
  showFacilityFilter: false,
  analyticsRangeDownloadPresent: true,
  showUiTrends: true,
  autosuggestLang: "PT",
  isShipmentGridNew: true,
  isViewAllGridNew: true,
  analyticsDefault: analyticDropdownOptions[0].value,
  isFilterGroupingPresent: true,
  isUIGridNew: true,
  isUEGridNew: true,
  exportPDFInAnalytics: false,
  minimumDateAllowed: "2021-01-01",
  isImpExpGraph: true,
  trendsTableCompanyID: {
    shipper: "hashed_id",
    consignee: "hashed_id",
    logistic: "hashed_id",
  },
  importer_exporter_graph_sort__options: [
    { value: "doc_count", value1: "date", label: "Shipments", table_header: "Total Shipments" },
    { value: "weight", label: "Weight (kg)", table_header: "Total Weight (kg)" },
    { value: "shipment_value", label: "Value (USD)", table_header: "Total Value (USD)" },
  ],
  apiEndPoints: {
    getArrivalDate: getApiUrl("getLatestArrivalDateBotswanaExports"),
    getSearchResult: getApiUrl("intelSearchBotswanaExport"),
    getAnalyticsData: getApiUrl("analytics/intelAnalyticsBotswanaExport"),
    saveProspectiveExportersApi: "addFavouriteCompany",
    saveProspectiveImportersApi: "addFavouriteCompany",
    downloadShipmentsApi: getApiUrl("create_excel_botswana_exports"),
    downloadUniqueImporterExporter: getApiUrl("create_excel_botswana_exports"),
    getShipmentByID: getApiUrl("intelSearchBotswanaExportShipmentByID"),
    getShipmentDownloadData: getApiUrl("renderToPdfBotswanaExports"),
    renderToPdfAnalytics: getApiUrl("renderToPdfAnalytics"),
    getUserPlanDetails: getApiUrl("getUserCreditsByPlan"),
    getCompanySlug: getApiUrl("companyProfiles/getSlug"),
    getSavedSearchPayloadById: getApiUrl("getSavedSearchPayloadById"),
    getMasterListsForAutoSearchFeilds: getApiUrl("dashboard/getMasterListsForAutoSearchFeilds"),
    getAnalyticsViewAll: getApiUrl("analytics/intelAnalyticsBotswanaExportViewAll"),
    getMissingTabData: getApiUrl("intelSearchWhatAreMissing"),
    getImpExpGraphData: getApiUrl("intelSearchBotswanaExportGraph"),
  },
  isAdvancedSearchAvailable: false,
  country_small: globalCountryDetails.bw_export.country_small,
  countryCaps: globalCountryDetails.bw_export.country_caps,
  product_id: globalCountryDetails.bw_export.product_id,
  compare_product_id: globalCountryDetails.bw_export.compareProduct,
  country_CamelCase: globalCountryDetails.bw_export.product_id,
  countryCode: globalCountryDetails.bw_export.countryCode,
  countryType: globalCountryDetails.bw_export.countryType,
  manyCountryType: globalCountryDetails.bw_export.manyCountryType,
  countryTypeCode: globalCountryDetails.bw_export.countryTypeCode,
  redirectionID: globalCountryDetails.bw_export.redirectionID,
  analyticsCountryID: globalCountryDetails.bw_export.analyticsCountryID,
  autoSuggestLanguage: autosuggestLanguageOptions.english,
  dateRangeHeading: "Shipment Date Range",
  monthRangeHeading: "Month of Export",
  picker: {
    monthPicker: false,
    datePicker: true,
  },
  tabKeyWords: {
    shipments: true,
    analytics: true,
    exporters: true,
    importers: true,
    logistics: false,
    whatYouAreMissing: true,
  },
  main_dropdown_options: {
    entire_bill_of_lading: false,
    product_description: true,
    product_hscode: true,
    exporters: true,
    importers: true,
    allCategory: true,
    logistics: false,
    ports: false,
    chemical_description: true,
  },
  searchCategoryList: globalCountryDetails.bw_export.defaultDropDown,
  specialFields: {
    hscode: "hsCode",
    consignee: "derivedConsigneeMasterName",
    shipper: "derivedShipperMasterName",
    weight: "weight",
    value: "shipmentValue",
    productCategory: "productCategory",
    sixDigitHsCode: "sixDigitHsCode",
  },
  filterObj: {
    countryOfImportRegion: "countryOfImportRegion",
    countryOfExportRegion: "countryOfExportRegion",
    consigneeJurisdictionCountryRegion: "consigneeJurisdictionCountryRegion",
    shipperJurisdictionCountryRegion: "shipperJurisdictionCountryRegion",
    consigneeName: "consigneeName",
    isImporter: "isImporter",
    shipperName: "shipperName",
    isExporter: "isExporter",
    hsCode: "hsCode",
    weight: "weight",
    shipmentValue: "shipmentValue",
    derivedConsigneeMasterName: "derivedConsigneeMasterName",
    derivedShipperMasterName: "derivedShipperMasterName",
    sixDigitHsCode: "sixDigitHsCode",
    productCategory: "productCategory",
    industryCategory: "industryCategory",
    quantityUnit: "quantityUnit",
    perUnitValue: "perUnitValue",
    quantityRange: "quantityRange",
  },
  booleanFilterObj: {},
  boxRangeFilterList: {
    weight: "weight",
    shipmentValue: "shipmentValue",
    perUnitValue: "perUnitValue",
    quantityRange: "quantityRange",
  },
  boxFilterObj: {
    weight: [],
    shipmentValue: [],
    perUnitValue: [],
    quantityRange: [],
  },
  localisationFilterObj: {
    countryOfImportRegion: "countryOfImport",
    countryOfExportRegion: "countryOfExport",
    consigneeJurisdictionCountryRegion: "consigneeJurisdictionCountry",
    shipperJurisdictionCountryRegion: "shipperJurisdictionCountry",
  },
  emptyFilterObj: {
    countryOfImportRegion: [],
    countryOfExportRegion: [],
    consigneeJurisdictionCountryRegion: [],
    shipperJurisdictionCountryRegion: [],
    consigneeName: [],
    isImporter: [],
    shipperName: [],
    isExporter: [],
    hsCode: [],
    weight: [],
    shipmentValue: [],
    sections: [],
    derivedConsigneeMasterName: [],
    derivedShipperMasterName: [],
    sixDigitHsCode: [],
    standardUnladingPortRegion: [],
    productCategory: [],
    industryCategory: [],
    quantityUnit: [],
    perUnitValue: [],
    quantityRange: [],
  },
  defaultBooleanFilterObj: {},
  selectAll: {
    countryOfImportRegion: false,
    countryOfExportRegion: false,
    consigneeJurisdictionCountryRegion: false,
    shipperJurisdictionCountryRegion: false,
    consigneeName: false,
    isImporter: false,
    shipperName: false,
    isExporter: false,
    hsCode: false,
    weight: false,
    shipmentValue: false,
    sections: false,
    derivedConsigneeMasterName: false,
    derivedShipperMasterName: false,
    sixDigitHsCode: false,
    productCategory: false,
    industryCategory: false,
    quantityUnit: false,
    perUnitValue: false,
    quantityRange: false,
  },
  specialMappingFields: {
    derived_hs_codes_string: {
      derived_hs_codes_string: {
        key: "derived_hs_codes_string",
        value: "",
      },
      derived_hs_codes_string_estimated: {
        key: "derived_hs_codes_string_estimated",
        value: "",
      },
      derived_hs_codes_string_estimated_is_present: {
        key: "derived_hs_codes_string_estimated_is_present",
        value: "Estimated HSCode",
      },
      fallback: "Not Available",
    },
    derived_shipment_value: {
      derived_shipment_value: {
        key: "derived_shipment_value",
        value: "",
      },
      derived_shipment_value_is_present: {
        key: "derived_shipment_value_is_present",
        value: "",
      },
      fallback: "Not Available",
    },
    shipper_party_name: {
      shipper_party_name: {
        key: "shipper_party_name",
        value: "",
      },
      fallback: "Not Declared",
    },
  },
  normalfilterList: [
    { heading: "Filter by Shipper Standardized Name", categoryName: categoryType.shipperDetails, eventKey: "32", key: "derivedShipperMasterName", type: filterType.normalFilter, label: "Shipper Standardized Name", viewAllPlaceHolder: "Search in Shipper Standardized Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Shipper Name", categoryName: categoryType.shipperDetails, eventKey: "5", key: "shipperName", type: filterType.normalFilter, label: "Shipper Name", viewAllPlaceHolder: "Search by Shipper Name", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Country of Export", categoryName: categoryType.shipperDetails, eventKey: "1", key: "countryOfExportRegion", altKey: "countryOfExport", type: filterType.localizeFilter, label: "Country of Export", viewAllPlaceHolder: "Search by Country of Export Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Shipper Type", categoryName: categoryType.shipperDetails, eventKey: "6", key: "isExporter", type: filterType.normalFilter, label: "Shipper Type", viewAllPlaceHolder: "Search in Is Exporter Filter", emptyFilterText: "", searchFilterString: "", showInput: false },
    { heading: "Filter by Consignee Standardized Name", categoryName: categoryType.consigneeDetails, eventKey: "31", key: "derivedConsigneeMasterName", type: filterType.normalFilter, label: "Consignee Standardized Name", viewAllPlaceHolder: "Search in Consignee Standardized Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Consignee Jurisdiction Country", categoryName: categoryType.consigneeDetails, eventKey: "1", key: "consigneeJurisdictionCountryRegion", altKey: "consigneeJurisdictionCountry", type: filterType.localizeFilter, label: "Consignee Jurisdiction Country", viewAllPlaceHolder: "Search by Consignee Jurisdiction Country", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Consignee Name", categoryName: categoryType.consigneeDetails, eventKey: "2", key: "consigneeName", type: filterType.normalFilter, label: "Consignee Name", viewAllPlaceHolder: "Search by Consignee Name", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Consignee Type", categoryName: categoryType.consigneeDetails, eventKey: "3", key: "isImporter", type: filterType.normalFilter, label: "Consignee Type", viewAllPlaceHolder: "Search in Is Importer Filter", emptyFilterText: "", searchFilterString: "", showInput: false },
    { heading: "Filter by Country of Import", categoryName: categoryType.consigneeDetails, eventKey: "1", key: "countryOfImportRegion", altKey: "countryOfImport", type: filterType.localizeFilter, label: "Country of Import", viewAllPlaceHolder: "Search by Country of Import Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Shipper Jurisdiction Country", categoryName: categoryType.shipperDetails, eventKey: "1", key: "shipperJurisdictionCountryRegion", altKey: "shipperJurisdictionCountry", type: filterType.localizeFilter, label: "Shipper Jurisdiction Country", viewAllPlaceHolder: "Search by Shipper Jurisdiction Country", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Product Category", categoryName: categoryType.cargoDetails, eventKey: "12", key: "productCategory", type: filterType.normalFilter, label: "Product Category", viewAllPlaceHolder: "Search in Product Category Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Industry Group", categoryName: categoryType.cargoDetails, eventKey: "33", key: "industryCategory", type: filterType.normalFilter, label: "Industry Group", viewAllPlaceHolder: "Search in Industry Group Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by HS Code", categoryName: categoryType.cargoDetails, eventKey: "19", key: "hsCode", type: filterType.hsCodeFilter, label: "HS Code", viewAllPlaceHolder: "Search by HS Code", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by 6 digit HS Code", categoryName: categoryType.cargoDetails, eventKey: "9", key: "sixDigitHsCode", type: filterType.normalFilter, label: "6 Digit HS Code", viewAllPlaceHolder: "Type to Search 6 digit HS Code", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Weight", categoryName: categoryType.cargoDetails, eventKey: "21", key: "weight", type: filterType.boxFilter, label: "Weight (kg)", viewAllPlaceHolder: "Search in Weight Filter", emptyFilterText: "", searchFilterString: "", showInput: false },
    { heading: "Filter by Shipment Value", categoryName: categoryType.cargoDetails, eventKey: "22", key: "shipmentValue", type: filterType.boxFilter, label: "Shipment Value (USD)", viewAllPlaceHolder: "Search in Shipment Value Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Quantity Unit", categoryName: "cargoDetails", eventKey: "32", key: "quantityUnit", additionalKey: "quantityRange", type: filterType.normalFilter, label: "Quantity", viewAllPlaceHolder: "Search Quantity Unit", emptyFilterText: "", searchFilterString: "", infoText: "", showInput: true, isParanthesesCapital: false, additionalType: "multiSelectRangeFilter" },
    { heading: "Filter by Per Unit Value (USD)", categoryName: "cargoDetails", eventKey: "32", key: "perUnitValue", type: filterType.multiSelectRangeFilter, label: "Per Unit Value (USD)", viewAllPlaceHolder: "", emptyFilterText: "", searchFilterString: "", infoText: "", showInput: false, isParanthesesCapital: false },
  ],
  internalFilterList: [
    { isVisible: true, key: "uniqueImportExporterShipment" },
    { isVisible: true, key: "uniqueImportExporterWeight" },
    { isVisible: false, key: "uniqueImportExporterValue" },
  ],
  highLightedColumnList: [
    { label: "Document Number", key: "export_id" },
    { label: "HS Code", key: "derived_hs_code" },
    { label: "Shipper Standardized Name", key: "derived_shipper_master_name" },
    { label: "Shipper Name", key: "shipper_name" },
    { label: "Consignee Standardized Name", key: "derived_consignee_master_name" },
    { label: "Consignee Name", key: "consignee_name" },
    { label: "Product Description", key: "product_description" },
  ],
  shipmentSorting: [
    { columnKey: "alias_shipment_date", value: "date", isDefault: true },
    { columnKey: "alias_derived_weight", value: "weight", isDefault: false },
    { columnKey: "alias_derived_shipment_value", value: "shipment_value", isDefault: false },
  ],
  exporterSorting: [
    { name: "Shipments", columnKey: "doc_count", value: "date", isDefault: false },
    { name: "Weight", columnKey: "weight", value: "weight", isDefault: false },
    { name: "Shipment Value", columnKey: "shipment_value", value: "shipment_value", isDefault: true },
  ],
  importerSorting: [
    { name: "Shipments", columnKey: "doc_count", value: "date", isDefault: false },
    { name: "Weight", columnKey: "weight", value: "weight", isDefault: false },
    { name: "Shipment Value", columnKey: "shipment_value", value: "shipment_value", isDefault: true },
  ],
  sortKeyMap: {
    date: "alias_shipment_date",
    weight: "alias_derived_weight",
    shipment_value: "alias_derived_shipment_value",
  },
  sortKeyUniqueImpExpMap: {
    date: "doc_count",
    weight: "weight",
    shipment_value: "shipment_value",
  },
  analyticsHeaderItems: [
    { label: "Total Shipments", key: "total_shipments", valuePrefix: "", valueSuffix: "" },
    { label: "Total Shipments Weight", key: "total_weight", valueSuffix: "kg", valuePrefix: "" },
    { label: "Total Shipments Value", key: "total_value", valueSuffix: "", valuePrefix: "USD" },
  ],
  analyticsFieldsMapping: [
    { key: "trends", filterKey: "", label: "Export Trends", type: analyticsType.trends, showTrends: true, showlevelTwo: false },
    { key: "country_of_import", filterKey: "countryOfImportRegion", label: "Countries of Import", type: analyticsType.horizontalCountry, showTrends: true, showlevelTwo: true, defaultKey: "six_digit_hs_code", modalHeader: "Inbound Countries" },
    { key: "hs_code", headerLabel: "HS Codes", filterKey: "hsCode", label: "HS Codes", type: analyticsType.hsCode, infoText: "Analytics data is based on the summary of the shipments obtained through a search query.<br/> Hence the data may contain aggregated results for all products, HS Codes present in the search results.", showlevelTwo: false, modalHeader: "2 digit HS Codes", defaultKey: "" },
    { key: "six_digit_hs_code", headerLabel: "6 digit HS Code", filterKey: "sixDigitHsCode", label: "6 digit HS Codes", type: analyticsType.hsCode, showTrends: true, showlevelTwo: true, defaultKey: "derived_shipper_master_name" },
  ],
  exporterTableColumn: [
    { key: "id", showUiUeTwoLevel: true, name: "S No.", selector: "id", dataTip: "", type: "", button: true, staticField: true },
    { key: "key", name: "Company Name", selector: "key", selector1: "country", selector1Code: "country_code", selector2: "state", selector3: "address", id: "hashed_id", type: "companyRedirect", fixedLengthUptoRank: 30, fixedLengthUptoTrend: 28, minWidth: "275px" },
    { key: "subKey", showUiUeTwoLevel: true, name: "Random Table", selector: "subKey", grow: 1, wrap: true },
    { key: "doc_count", name: "Shipments", selector: "doc_count", sortable: true, dataTip: "", type: "", grow: 1, wrap: true, isCommaFormat: true },
    { key: "weight", name: "Weight(kg)", selector: "weight", sortable: true, dataTip: "", type: "", grow: 1, wrap: true, isCommaFormat: true, fixedValueUpto: 2 },
    { key: "shipment_value", name: "Shipment Value (USD)", selector: "shipment_value", sortable: true, dataTip: "", type: "conditionalBlur", grow: 1, wrap: true, isCommaFormat: true, fixedValueUpto: 2, upgradeText: "To view Shipment, you would need to upgrade to higher plan." },
    { key: "oldest_shipment_date", name: "First Exported On", selector: "oldest_shipment_date", grow: 1, wrap: true },
    { key: "recent_shipment_date", name: "Last Exported On", selector: "recent_shipment_date", grow: 1, wrap: true },
    { key: "market_share", showUiUeTwoLevel: true, isNameVariable: true, name: "% share by", selector: "market_share", type: "", grow: 1, wrap: true },
  ],
  importerTableColumn: [
    { key: "id", showUiUeTwoLevel: false, name: "S No.", selector: "id", dataTip: "", type: "", button: true, staticField: true },
    { key: "key", name: "Company Name", selector: "key", selector1: "country", selector1Code: "country_code", selector2: "state", selector3: "address", id: "hashed_id", type: "companyRedirect", fixedLengthUptoRank: 30, fixedLengthUptoTrend: 28, minWidth: "275px" },
    { key: "subKey", showUiUeTwoLevel: true, name: "Random Table", selector: "subKey", grow: 1, wrap: true },
    { key: "doc_count", name: "Shipments", selector: "doc_count", sortable: true, dataTip: "", type: "", grow: 1, wrap: true, isCommaFormat: true },
    { key: "weight", name: "Weight(kg)", selector: "weight", sortable: true, dataTip: "", type: "", grow: 1, wrap: true, isCommaFormat: true, fixedValueUpto: 2 },
    { key: "shipment_value", name: "Shipment Value (USD)", selector: "shipment_value", sortable: true, dataTip: "", type: "conditionalBlur", grow: 1, wrap: true, isCommaFormat: true, fixedValueUpto: 2, upgradeText: "To view Shipment, you would need to upgrade to higher plan." },
    { key: "oldest_shipment_date", name: "First Imported On", selector: "oldest_shipment_date", grow: 1, wrap: true },
    { key: "recent_shipment_date", name: "Last Imported On", selector: "recent_shipment_date", grow: 1, wrap: true },
    { key: "market_share", showUiUeTwoLevel: true, isNameVariable: true, name: "% share by", selector: "market_share", type: "", grow: 1, wrap: true },
  ],
  viewShipmentDetails: [
    {
      id: 1,
      title: "",
      growValue: 12,
      isHeader: true,
      imgUrl: "",
      data: [
        { label: "Shipment Date", value: "shipment_date", dateFormat: true, monthFormat: false },
        { label: "Document Number", value: "export_id" },
        { label: "Item Number", value: "item_number" },
        { label: "HS Code", value: "derived_hs_code" },
      ],
    },
    {
      id: 2,
      title: "Shipment Origin Details",
      isConnectedColumn: true,
      isCompactHeader: true,
      growValue: 6,
      isHeader: false,
      imgUrl: "",
      data: [
        { label: "Country of Export", value: "derived_country_of_export", countryFlag: true, countryCodeField: "derived_country_of_export_code" },
        { label: "Shipper Standardized Name", type: "redirect", companyIdKey: "derived_shipper_master_company_id", companyKey: "", derivedCompanyKey: "derived_shipper_master_name" },
        { label: "Shipper Name", value: "shipper_name" },
        { label: "Shipper Type", value: "derived_is_exporter" },
        { label: "Shipper Jurisdiction Country", value: "derived_shipper_jurisdiction_country", countryFlag: true, countryCodeField: "derived_shipper_jurisdiction_country_code" },
      ],
    },
    {
      id: 3,
      title: "Shipment Destination Details",
      growValue: 6,
      isHeader: false,
      isCompactHeader: true,
      imgUrl: "",
      data: [
        { label: "Country of Import", value: "derived_country_of_import", countryFlag: true, countryCodeField: "derived_country_of_import_code" },
        { label: "Consignee Standardized Name", type: "redirect", companyIdKey: "derived_consignee_master_company_id", companyKey: "", derivedCompanyKey: "derived_consignee_master_name" },
        { label: "Consignee Name", value: "consignee_name" },
        { label: "Consignee Type", value: "derived_is_importer" },
        { label: "Consignee Jurisdiction Country", value: "derived_consignee_jurisdiction_country", countryFlag: true, countryCodeField: "derived_consignee_jurisdiction_country_code" },
      ],
    },
    {
      id: 4,
      title: "Cargo Details",
      growValue: 6,
      isHeader: false,
      imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251778/images/website/api-integration/delivery-box_1_1_niaysj.svg",
      data: [
        { label: "Product Description", value: "product_description", isCapitalise: true },
        { label: "Quantity", value: "quantity", dynamicUnit: true, unitField: "derived_quantity_unit" },
        { label: "Per Unit Value", value: "derived_shipment_value_usd_per_quantity_unit", valuePrefix: "USD ", isCommaFormat: true },
        { label: "Net Weight (kg)", value: "net_weight_kg", valueSuffix: " kg", isCommaFormat: true },
        { label: "Shipment Value (USD)", value: "fob_value_usd", valuePrefix: "USD ", isCommaFormat: true },
      ],
    },
  ],
  onboardingSteps: [
    { selector: "#reacttourdaterange", disableInteraction: true, header: "", description: "Customize your search basis shipment departure date", float: "", position: "left" },
    { selector: "#reacttourFilter", disableInteraction: true, header: "Filters Button", description: "Use filters to get most relevant shipments for you", float: "right", position: "right" },
    { selector: "#reacttourMainSearch", disableInteraction: true, header: "Start searching for Brazil Exports Shipments", description: "Entire Bill of Lading, HS Codes, Product Description, and Suppliers", float: "right", position: "bottom" },
    { selector: "#nav-tab", disableInteraction: true, header: "", description: "View unique shippers in the search result and add them to your prospect list.", float: "right", position: "bottom" },
    { selector: ".saved-search-button", disableInteraction: true, header: "", description: "Reload from Saved Searches, for quick shipments data access.", float: "", position: "bottom" },
  ],
  defaultUeUiSecondLevelKey: "country_of_import",

  twoColumnMapping: {
    country_of_import: "Country of Import",

    derived_consignee_master_name: "Unique Importers",
    derived_shipper_master_name: "Unique Exporters",
    six_digit_hs_code: "6 digit HS Codes",
  },
};

const BotswanaExportSearch = () => {
  return <Shipments defaultData={defaultData} analyticDropdownOptions={analyticDropdownOptions} trendsDropdownOptions={trendsDropdownOptions} />;
};
export default BotswanaExportSearch;
